import {L} from './landcare-toolkit';
import {LTServices} from './lt-services';
import {FabControl} from "./map-controls";
import {IToastService} from "../services/ToastService";
import {LocateMeControl} from "./map-controls/locate-me-control";
import {IMapControlService} from "./map-controls/map-control-service";
import {createPortalContextMenu} from "./map-controls/context-menu";
import {ICoordinateAdjustmentService} from "../services/coordinate-adjustment";
import {PinAndExtras} from "../services/PinApi";
import {conditions} from "../utility/conditions";
import {_F} from "../utility/func";
import {ITileErrorMonitoring} from "../services/tile-error-monitoring";
import {Feature, Geolocation, Map as OlMap, MapBrowserEvent} from 'ol';
import {defaults, ScaleLine} from "ol/control";
import {DoubleClickZoom, defaults as interactionDefaults} from "ol/interaction";
import SimpleGeometry from "ol/geom/SimpleGeometry";
import {ResizeSensor} from 'css-element-queries';

export module LTMap {

	export interface IQueryString {
		parseKeyValue: (queryString: string) => any;
		toKeyValue: (obj: any) => string;
	}

	import is_touch_device = conditions.is_touch_device;
	import pinTitleFromFeature = _F.pinTitleFromFeature;
	export class LandcareMap {
		elementClass = 'landcare-openlayers-map';
		restrict = 'E';
		// noinspection JSUnusedGlobalSymbols
		transclude = true;
		replace = true;
		protected mapWidth: number;
		protected mapHeight: number;
		protected wasVisible: boolean = false;
		scope = {

		};
		eventListeners($: ng.IAugmentedJQueryStatic, $scope: ng.IScope) {
			let mapService = this.mapService;
			function fit(event, options) {
				let details = options['detail'] || event.originalEvent && event.originalEvent['detail'] || {};
				details['size'] = mapService.map.getSize();


				console.log(`details ${JSON.stringify(details)}`);

				mapService.view.fit(
					L.util.Map.defaultExtent(), details);
			}
			$scope.$on(L.Events.OL_RESET_EXTENT, fit);
			$scope.$root.$on('ol-zoom-scale', (event: ng.IAngularEvent,
				scale: number, scales: number[]) => {
				const v = this.mapService.view;
				// if the center is offset due to transparent panes, we want to memo the center before we zoom
				// const center = this.coordinateAdjustmentService.getCentreAdjustedForScreenSpace(this.mapService.map);
				let index = scales.indexOf(scale);
				v.setZoom(index);
				// v.setCenter(center);
			});
		}
		template = '<div class="' + this.elementClass + '"></div>';
		protected element: ng.IAugmentedJQuery;
		protected $scope: ng.IScope;
		constructor(protected mapService: LTServices.IMapService,
					protected $location: ng.ILocationService,
					protected QueryString: IQueryString,
					protected toastService: IToastService,
					protected mapControlService: IMapControlService,
					protected coordinateAdjustmentService: ICoordinateAdjustmentService,
					protected tileErrorMonitoring: ITileErrorMonitoring) {
			tileErrorMonitoring.init();
		}

		whenVisible() {
			let element = this.element;
			let $scope = this.$scope;

			let parent = element.parent();
			let getNumberStyle = (el, prop) => {
				let style = window.getComputedStyle(el[0]);
				return Number(style[prop].substring(0, style[prop].length - 2));
			};
			let width = getNumberStyle(parent, 'width');
			let height = getNumberStyle(parent, 'height');
			this.mapWidth = this.mapWidth || width;
			this.mapHeight = this.mapHeight || height;
			element.css({
				width: this.mapWidth,
				height: this.mapHeight
			});
			let view = L.util.View.defaultView(this.$location);

			let controlOptions = this.mapControlService.getControlOptions();

			const overviewMapControl = controlOptions.hasOverviewMap ? this.mapService.overviewLayer : null;
			let transparencySliderControl = controlOptions.transparencySlider ? this.mapService.transparencySliderControl : null;

			let customControls: any[] = [
				transparencySliderControl,
				overviewMapControl,
				new ScaleLine({
					className: "ol-scale-line"
				})
			];


			if ("geolocation" in navigator && controlOptions.hasGeolocation) {
				let locateControl = new LocateMeControl(navigator.geolocation, null, this.toastService);
				customControls.push(locateControl);
				let qString = window.location.search.length ? this.QueryString.parseKeyValue(window.location.search.substr(1)) : {};
				if(qString['locate']) {
					locateControl.doGeoLocate();
				}
			}

			if (controlOptions.hasContextMenu) {
				customControls.push(createPortalContextMenu($scope, this.mapService));
			}

			if (controlOptions.hasAddPinButton) {
				customControls.push(new FabControl({
					onClick: () => {
						$scope.$apply(() =>
						{
							$scope.$root.$broadcast('show-add-pins');
						});
					},
					iconClass: 'icon icon-pins2-add',
					extraClasses: 'add-pins-control hidden-sm hidden-md hidden-lg hidden-xl',
					title: 'Add soil summary pin'
				}));
			}

			if (controlOptions.hasMobileSettingsButton) {
				customControls.push(new FabControl({
					onClick: () => {
						$scope.$apply(() => $scope.$root.$broadcast('show-settings'));
					},
					iconClass: 'icon icon-cog',
					extraClasses: 'settings-control hidden-sm hidden-md hidden-lg hidden-xl',
					title: 'Settings'
				}));
			}

			customControls = customControls.filter((it) => !!it);

			let getDoubleClickZoom = (map : OlMap) : DoubleClickZoom[] => {
				return map.getInteractions().getArray().filter((it): it is DoubleClickZoom => it instanceof DoubleClickZoom);
			};

			let myMapOptions = {
				controls: defaults({
					attribution : true,
					attributionOptions: {
						collapsible: false
					},
					rotate: false
				}).extend(customControls),
				interactions: interactionDefaults({
					pinchRotate: false,
					altShiftDragRotate: false,
					keyboard: true
				}),
				layers: this.mapService.layers, // layers,
				//renderer: common.getRendererFromQueryString(),
				view: view
			};

			const mapOptions = {
				...myMapOptions,
				target: element[0],
				keyboardEventTarget: document
			};

			const map = new OlMap(mapOptions);

            view.fit(L.util.Map.defaultExtent(), {
                padding: this.coordinateAdjustmentService.padding(),
				size: map.getSize()
            });

			$scope.$on('drawstart', () => {
				getDoubleClickZoom(map).forEach((it) => it.setActive(false));
			});

			$scope.$on('drawend', () => {
				this.mapService.getDefaultClickInteraction().skipNext();
				this.mapService.getDefaultClickInteraction().setActive(true);
				window.setTimeout(() => {
						getDoubleClickZoom(map).forEach((it) =>	it.setActive(true));
					}, 100);
			});

			let hoveredFeature = null;
			let tooltip = null;
			let currentTooltipText: string = '';

			let setTooltip = function(title : string, x : number, y : number) {
				if (title) {
					if (!tooltip) {
						let tooltipEl = document.createElement("div");
						document.querySelector('body').appendChild(tooltipEl);

						tooltip = angular.element(tooltipEl).addClass('map-tooltip')
							.css('left', '10px')
							.css('top', '25px');
					}
					if (title !== currentTooltipText) {
						tooltip.html(title);
						currentTooltipText = title;
					}
					// tooltip.html(title).css('left',(x + 10).toString() + 'px').css('top', (y + 25).toString() + 'px').css('display', null);
					tooltip.css('transform', `translate(${x}px, ${y}px)`).css('display', null);
				} else {
					if (tooltip)tooltip.css('display', 'none');
				}

				if (is_touch_device()) {
					const currentFeature = hoveredFeature;
					window.setTimeout(() => {
						if (hoveredFeature && hoveredFeature === currentFeature) {
							hoveredFeature.set('hover', false);
							setTooltip(null, 0, 0);
							// Broadcasting hoveredPin:change - to null
							$scope.$root.$apply(<any> $scope.$root.$broadcast('hoveredPin:change', {
								oldValue : hoveredFeature && hoveredFeature.get('pin'),
								newValue : null
							}));
							hoveredFeature = null;
						}								
					}, 3000);
				}
			};

			map.on('pointermove', (ev : MapBrowserEvent<any>) => {
				let map = ev.map;

				// is the pointer over a pins?
				const result = map.forEachFeatureAtPixel(
					ev.pixel,
					(f/*, layer*/ ) => {
						return pinTitleFromFeature(f as Feature) || f.get('pin') ? f : undefined;
					});

				if (result) {
                    const {clientX, clientY} : any = ev.originalEvent;
                    setTooltip(pinTitleFromFeature(result as Feature) || 'unnamed pin', clientX, clientY);
				}

				if (result && result instanceof Feature && result != hoveredFeature) {
					// a pin is being hovered over
					result.set('hover', true);
					if (result.get('pin')) {
						let pin : PinAndExtras = result.get('pin');
						// Broadcasting hoveredPin:change
						this.$scope.$root.$apply(<any> this.$scope.$root.$broadcast('hoveredPin:change', {
							oldValue : hoveredFeature && hoveredFeature.get('pin'),
							newValue : pin
						}));
					}
					if (hoveredFeature) {
						hoveredFeature.set('hover', false);
					}
					hoveredFeature = result;
				} else if (!result && hoveredFeature) {
					hoveredFeature.set('hover', false);
					setTooltip(null, 0, 0);
					// Broadcasting hoveredPin:change - to null
					this.$scope.$root.$apply(<any> this.$scope.$root.$broadcast('hoveredPin:change', {
						oldValue : hoveredFeature && hoveredFeature.get('pin'),
						newValue : null
					}));
					hoveredFeature = null;
				}
			});

			let lastState = null;
            let setLocationCenter = () => {
				let state = {
					center: map.getView().getCenter(),
					zoom: Math.round(map.getView().getZoom())
				};
				// don't want to update if nothing changed!
				if (angular.equals(lastState, state)) {
					return;
				}
				let center = state.center;
				let zoom = state.zoom;

				$scope.$root.$broadcast('mapZoomChanged', zoom);
				$scope.$root.$broadcast('setLocationCenter', center, zoom);
				lastState = state;
			};


			console.log('setLocationCenter added');
			map.on('moveend', () => {
				setLocationCenter();
			});
			let geolocation = new Geolocation({
				projection: view.getProjection()
			});

			geolocation.on('change', () => {
				let view = map.getView();
				let simpleAccuracy: SimpleGeometry = <SimpleGeometry> geolocation.getAccuracyGeometry();
				view.fit(simpleAccuracy, { size: map.getSize() });
				geolocation.setTracking(false);
			});
			let stripPx = (val : string) : number => Number(val.slice(0, -2));

			new ResizeSensor(element[0], () => {
				let parent = element.parent();
				let style = window.getComputedStyle(parent[0]);

				let width = stripPx(style.width);
				let height = stripPx(style.height);
				if (width && height) {
					this.mapWidth = width;
					this.mapHeight = height;
					element.css('width', this.mapWidth);
					element.css('height', this.mapHeight);
					map.updateSize();
				}
			});

			window['map'] = map;
			this.mapService.view = view;
			this.mapService.setMap(map);
			this.eventListeners(angular.element, $scope);
			this.dispatchVisibleEventWhenChange();


			if (window.location.search.length) {
				let searchObject = this.QueryString.parseKeyValue(window.location.search.substr(1));
				if (searchObject['c']) {
					console.log("Showing location", searchObject['c'], searchObject['z']);
					let centre = searchObject['c'].split(',').map((n) => Number(n)).filter((n) => !isNaN(n));
					if (centre.length == 2) {
						map.getView().setCenter(centre);
					}

					if (searchObject['z']) {
						map.getView().setZoom(searchObject['z']);
					}
				}
			}
		}
		
		dispatchVisibleEventWhenChange(): void {
			let check = () => {
				if (!this.checkIfVisibleAndDispatch()) {
					L.util.Polyfills.requestAnimationFrame(check);
				}
			};
			L.util.Polyfills.requestAnimationFrame(check);
		}
		checkIfVisibleAndDispatch() {
			let isVisible = this.element.css('display') != 'none';
			let alreadyDispatched = isVisible === this.wasVisible;
			if (!alreadyDispatched) {
				this.dispatchVisibleEvent(isVisible);
				this.wasVisible = isVisible;
				return true;
			}

			return false;
		}
		dispatchVisibleEvent(visible: boolean): void {
			angular.element(<any> window).triggerHandler('lt-map-visible', visible);
			this.wasVisible = visible;
			console.log('event: lt-map-visible', visible);
		}
		callWhenVisible(element: ng.IAugmentedJQuery, f: Function, fArguments: any[] = []) {
			if (element.css('display') != 'none') {
				return f.apply(this, fArguments);
			}
			let step = () => {
				this.callWhenVisible(element, f, fArguments);
			};
			L.util.Polyfills.requestAnimationFrame(step);
		}
		callWhenIs(element: any, selector: string, positive: boolean, f: Function, fArguments: any[] = []) {
			if (element.is(selector) === positive) {
				return f.apply(this, fArguments);
			}
			let step = () => {
				this.callWhenIs(element, selector, positive, f, fArguments);
			};
			L.util.Polyfills.requestAnimationFrame(step);
		}
		// noinspection JSUnusedLocalSymbols
		link = ($scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => { //(scope: any, element: JQuery, attrs: any, $http: any) {
			/**
			 * The following makes sure the <lt-map/> directive is not done
			 * more than once, because SinglePage populates the content
			 * twice.
			 */
			this.element = element;
			this.$scope = $scope;

			this.mapService.promise.then(() => {
				this.callWhenVisible(element, this.whenVisible);
			});
		};
		static factory(): ng.IDirectiveFactory {
			const directive = (
					mapService: LTServices.IMapService,
					$location: ng.ILocationService,
					QueryString: IQueryString,
					toastService: IToastService,
					mapControlService: IMapControlService,
                    coordinateAdjustmentService: ICoordinateAdjustmentService,
					tileErrorMonitoring: ITileErrorMonitoring) =>
				new LandcareMap(mapService, $location, QueryString, toastService, mapControlService, coordinateAdjustmentService, tileErrorMonitoring);

			directive.$inject = [
				'landcareMapService',
				'$location',
				'myQueryString.QueryString',
				'toastService',
				'mapControlService',
				'coordinateAdjustmentService',
				'tileErrorMonitoring'
			];
			return directive;
		}
	}
	export class LandcareSearchresults {
		elementClass = 'landcare-searchresults';
		restrict = 'E';
		scope = {
			results: '=results'
		};
		template = '<div class="' + this.elementClass + '"><li ng-repeat="for result in results">{{result}}</li></div>';
		protected element: ng.IAugmentedJQuery;
		protected $scope: ng.IScope;
		constructor() {

		}
		// noinspection JSUnusedLocalSymbols
		link = ($scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, arg1) => {
			$scope['results'] = ['hello','world','here'];
			$scope['updatePlaces'] = function() {
				$scope['places'] = [
					'Hello',
					'world',
					'This'
				];
			};
		};
		static factory(): ng.IDirectiveFactory {
			const directive = () => new LandcareSearchresults();
			directive.$inject = [];
			return directive;
		}
	}

	export class Transitionend {
		eventName : string = 'transitionend';
		restrict = 'A';
		constructor(protected $parse: ng.IParseService, protected $rootScope: ng.IRootScopeService) {
		}
		compile = ($element : ng.IAugmentedJQuery, attr: ng.IAttributes) => {
			let fn = this.$parse(attr["ltTransitionend"]);
			let self = this;
			return function(scope: ng.IScope, element: ng.IAugmentedJQuery) {
				element.on(self.eventName, function (event) {
					let callback = function() {
						fn(scope, {$event: event});
					};

					scope.$apply(callback);
				});
			}

		};
		static factory(): ng.IDirectiveFactory {
			const directive = ($parse: ng.IParseService, $rootScope: ng.IRootScopeService) =>
				new Transitionend($parse, $rootScope);
			directive.$inject = ['$parse', '$rootScope'];
			return directive;
		}
	}

	export function init(): void {
		angular
			.module('ltMapDirective', ['ltMapService', 'myQueryString', 'autocomplete'])
			/**
			 * Directive instanciated in HTML with <lt-map .../>
			 */
			.directive('ltMap', LandcareMap.factory())
            // .directive('ltMap', ['landcareMapService', '$location', 'myQueryString.QueryString', 'toastService', 'mapControlService', LandcareMap.factory()])
            .directive('ltSearchresults', [LandcareSearchresults.factory()])
			.directive('ltTransitionend', ['$parse', '$rootScope', Transitionend.factory()]);
	}
}
